export const otherKeys = {
  configuration: (id: string) => ["configuration", id],
};
